const config = {
  stripe_obj: {
    stripe_priceid: 'price_1ILqQ2CB1XTVvDWIWjnDT6PN',
  },
}

export default config
